import { isNotNumber } from '@clara/utils'

export function toNumber(value: any) {
  const num = parseFloat(value)
  return isNotNumber(num) ? 0 : num
}
